// extracted by mini-css-extract-plugin
export default {"container":"ShopHeader_container__pbv4h","text1":"ShopHeader_text1__wK-d5","text2":"ShopHeader_text2__MB1cZ","img":"ShopHeader_img__cBFJo"};